import {
    useContext,
    Children,
    type FC
} from "react";
import {
    View
} from "react-native";
import type IPopoverFooterProps from "./type";
import stylesheet, {
    getPopoverFooterRadius,
    getPopoverFooterSize,
    useStyles
} from "./stylesheet";
import {
    decoratePopoverFooterChild
} from "./util";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    usePointerType
} from "../../../../helpers/pointer";
import {
    PopoverLayoutContext,
    usePopoverContext
} from "../../context";

const PopoverFooter: FC<IPopoverFooterProps> = ({
    customTheme: customThemeProp,
    isDivided = false,
    align = "end",
    children,
    style
}) => {
    const context = usePopoverContext({
        part: "Footer"
    });

    const {
        isSheet
    } = useContext(PopoverLayoutContext);

    const customTheme = customThemeProp ?? context?.customTheme;

    const {
        radiuses,
        borders,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const pointerType = usePointerType();

    const currentAlign = isSheet ? "stretch" : align;

    const isStretch = currentAlign === "stretch";

    const {
        footer: footerDynamicStyle
    } = useStyles({
        isDivided: isSheet ? false : isDivided,
        align: currentAlign,
        borders,
        colors,
        spaces
    });

    if(!context) {
        return null;
    }

    const size = getPopoverFooterSize({
        pointerType,
        isSheet
    });

    const borderRadius = getPopoverFooterRadius({
        radiuses,
        borders,
        spaces
    });

    return <View
        style={[
            style,
            stylesheet.footer,
            footerDynamicStyle
        ]}
    >
        {
            Children.map(children, (node) => decoratePopoverFooterChild({
                stretchStyle: stylesheet.stretch,
                borderRadius,
                customTheme,
                isStretch,
                node,
                size
            }))
        }
    </View>;
};
export default PopoverFooter;
